import React from 'react';
import { AvatarProps } from 'antd';

import {
  StyledAntdAvatar,
} from './style';

const CVAvatar = (props: AvatarProps): JSX.Element => (
  <StyledAntdAvatar {...props} />
);

export default CVAvatar;
